import { createContext, useContext } from "react";

// Propagates ShojiBacking's `occluded` down to its PanelText/PanelRule
// children automatically. Without this, every text line in a panel (5+ in
// PauseScreen, more in the menu/teach panels to come) would need to repeat
// `occluded={false}` by hand — one missed prop silently breaks the "always
// visible over frozen gameplay" invariant for just that line. Children can
// still pass an explicit `occluded` to override the panel's default.
const PanelOcclusionContext = createContext(true);

export const PanelOcclusionProvider = PanelOcclusionContext.Provider;

export function usePanelOccluded(explicit?: boolean): boolean {
  const contextValue = useContext(PanelOcclusionContext);
  return explicit ?? contextValue;
}
